export const initTheme = {
  isTheme: false,
};
